import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default' }) => {
  const onHero = variant === 'onDark';
  return (
    <Link to="/" className="flex items-center group">
      <img
        src="/bhuvilogo.png"
        alt="Bhuvi Life Spaces"
        className={`h-10 w-auto max-w-[min(88vw,15rem)] object-contain transition-all duration-300 sm:h-11 md:h-12 lg:h-14 group-hover:opacity-90 ${
          onHero ? 'brightness-0 invert' : ''
        }`}
        onError={(e) => {
          e.target.style.display = 'none';
          const parent = e.target.parentElement;
          if (parent && !parent.querySelector('.fallback-logo')) {
            const fallback = document.createElement('span');
            fallback.className = `fallback-logo text-xl md:text-2xl font-light tracking-wide ${
              onHero ? 'text-white' : 'text-gray-700'
            }`;
            fallback.textContent = 'Bhuvi';
            parent.appendChild(fallback);
          }
        }}
      />
    </Link>
  );
};

export default Logo;
